import { FloatingFilterButton } from '~shared/ui/floating-filter-button';

import { BusinessSelect, StoreSelect } from './dashboard-filter-fields';

type Props = {
  hideMerchantFilter: boolean;
  activeCount: number;
  onApply: () => void;
  onClear: () => void;
};

export function DashboardFiltersMobile({
  hideMerchantFilter,
  activeCount,
  onApply,
  onClear,
}: Props) {
  return (
    <FloatingFilterButton
      activeCount={activeCount}
      onApply={onApply}
      onClear={onClear}
    >
      {!hideMerchantFilter && <BusinessSelect />}
      <StoreSelect />
    </FloatingFilterButton>
  );
}
